// @flow
import type { rexButtonType } from '../../components/types';
import { buttonStateMap } from '../../constant';

const createInitialState = (rexButtons: ?(rexButtonType[])) => {
  let buttonStateByCId;

  if (rexButtons) {
    buttonStateByCId = {};
    for (let i = 0; i < rexButtons.length; i += 1) {
      const rexbutton = rexButtons[i];
      const cId = rexbutton.cId;

      // Initial states
      const isChecked = !!rexbutton.below && !!rexbutton.below.isChecked;
      const buttonState = buttonStateMap.DISABLED;
      const validationText = '';
      const informationText = '';
      const isLoggedIn = false;

      buttonStateByCId = Object.assign(buttonStateByCId, {
        [cId]: {
          isChecked,
          buttonState,
          validationText,
          informationText,
          isLoggedIn,
        },
      });
    }
  }

  return {
    buttonStateByCId,
  };
};

export default createInitialState;



// WEBPACK FOOTER //
// ./src/redux/state/createInitialState.js